import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from './useUser';
import { Route, routes } from '../routing/routes';

/**
 * Automatically redirect to the login page for an action
 * and optionally back to somewhere else afterwards
 * @param opts
 */
export const useLoginRedirect = (opts?: UseLoginRedirectOptions) => {
  const navigate = useNavigate();
  const { account } = useUser();

  useEffect(() => {
    if (!account?.dusktech?.userId) {
      navigate(routes.login({ redirect: opts?.follow }));
    }
  }, [account.dusktech?.userId, navigate, opts?.follow]);

  return;
};

export type UseLoginRedirectOptions = {
  follow?: Route;
};
